/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationManagerResource } from './';
import {
    OrganizationManagerResourceFromJSON,
    OrganizationManagerResourceFromJSONTyped,
    OrganizationManagerResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationManagersResource
 */
export interface OrganizationManagersResource {
    /**
     * 
     * @type {OrganizationManagerResource}
     * @memberof OrganizationManagersResource
     */
    salesManager?: OrganizationManagerResource;
    /**
     * 
     * @type {OrganizationManagerResource}
     * @memberof OrganizationManagersResource
     */
    customerSuccessManager?: OrganizationManagerResource;
    /**
     * 
     * @type {OrganizationManagerResource}
     * @memberof OrganizationManagersResource
     */
    finOpsManager?: OrganizationManagerResource;
}

/**
 * Check if a given object implements the OrganizationManagersResource interface.
 */
export function instanceOfOrganizationManagersResource(value: object): value is OrganizationManagersResource {
    return true;
}

export function OrganizationManagersResourceFromJSON(json: any): OrganizationManagersResource {
    return OrganizationManagersResourceFromJSONTyped(json, false);
}

export function OrganizationManagersResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationManagersResource {
    if (json == null) {
        return json;
    }
    return {
        
        'salesManager': json['salesManager'] == null ? undefined : OrganizationManagerResourceFromJSON(json['salesManager']),
        'customerSuccessManager': json['customerSuccessManager'] == null ? undefined : OrganizationManagerResourceFromJSON(json['customerSuccessManager']),
        'finOpsManager': json['finOpsManager'] == null ? undefined : OrganizationManagerResourceFromJSON(json['finOpsManager']),
    };
}

export function OrganizationManagersResourceToJSON(value?: OrganizationManagersResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'salesManager': OrganizationManagerResourceToJSON(value['salesManager']),
        'customerSuccessManager': OrganizationManagerResourceToJSON(value['customerSuccessManager']),
        'finOpsManager': OrganizationManagerResourceToJSON(value['finOpsManager']),
    };
}

